import { useCallback, useContext, useState } from 'react';

/**
 * @param {boolean} initialValue
 * @returns {[
 *   boolean,
 *   (
 *     isCancelled?: () => boolean,
 *     fn: () => Promise<any>
 *   ) => Promise<any>,
 *   React.Dispatch<React.SetStateAction<boolean>>,
 * ]}
 */
const useLoading = (initialValue) => {
  const [ loading, setLoading ] = useState(initialValue);

  /**
   * Sets the loading variable to true before calling the provided function, once the
   * function returns the isCancelled function will be called and if it returns true
   * the loading state will be set back to false. If isCancelled is not a function the
   * loading state will also be set to false when the function returns.
   * 
   * @type {(
    *   isCancelled?: () => boolean,
    *   fn: () => Promise<any>
    * ) => Promise<any>}
    */
   const inLoading = useCallback(async (isCancelled, fn) => {
     try {
       setLoading(true);
       return await fn();
     } finally {
       if (typeof isCancelled === 'function' && isCancelled()) return;
       setLoading(false);
     }
   }, []);

  return [loading, inLoading, setLoading];
}

export default useLoading;